// @mui
import { Stack } from '@mui/system';
import { Box, Typography } from '@mui/material';
import _ from 'lodash';
//reducers
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
//components
import { ListHeaderWithActions } from 'theme/elements/List';
//constants
import PaymentsTable from './PaymentsTable';
import { getNewBeneficiary } from 'state/reducers/beneficiary.reducers';
import CreateMessage from 'components/CreateMessage';
import { UserPermission } from 'constants/user.constants';
import { getUserPermission } from 'state/reducers/user.reducers';
import { BeneficiaryStatus } from 'constants/beneficiary.constants';
import { isLoading } from 'state/reducers/pay.reducers';

export default function Payments(props: {}) {
  const t = useAppSelector(selectTranslations);
  const beneficiary = useAppSelector(getNewBeneficiary);
  const userPermission = useAppSelector(getUserPermission);
  const ifLoading = useAppSelector(isLoading);
  return beneficiary?.paymentsList && beneficiary?.paymentsList.length > 0 ? (
    <Stack spacing={{ sm: 3, xs: 0 }}>
      <Typography display={{ xs: 'none', sm: 'block' }} variant="h3">
        {t('page.beneficiary.profile.payment_history.header.title')}
      </Typography>
      <PaymentsTable data={beneficiary.paymentsList} currencyId={beneficiary.currencyId} />
    </Stack>
  ) : (
    <>
      {!ifLoading && (
        <CreateMessage
          title={t('page.beneficiary.profile.no_payment.header.title')}
          imageKey={'page.beneficiary.profile.payments.empty.icon'}
          noAction={true}
        />
      )}
    </>
  );
}
